import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Topic } from '@shapeable/gesda-types';
import { ContentTabs, ContentTabSpec, useModal } from '@shapeable/ui';
import { AiUpperCaseIconGlyph } from '@shapeable/icons';
import { compact } from 'lodash';
import { TopicView } from '../../types';
import { sortBy } from 'lodash';
import { useCurrentEditionMembers } from '../../hooks/use-current-edition-members';
import { filterEntitiesWithLinkedSite } from '../../utils/filter-entities-with-linked-site';
import { AiChatInterfaceModal } from '../elements/ai-chat-interface-modal';
const cls = classNames('topic-tabs-layout');

// -------- Types -------->

// -------- Props -------->

export type TopicTabsLayoutProps = Classable & HasChildren & { 
  entity?: Topic;
  activeView?: TopicView;
  setActiveView?: (view: TopicView) => void;
};

export const TopicTabsLayoutDefaultProps: Omit<TopicTabsLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->


const TabsStyles = breakpoints({
  base: css`
  `,
});

// -------- Components -------->

const My = {
  Tabs: styled(ContentTabs)<ContainerProps>`${TabsStyles}`,

};

export const TopicTabsLayout: Shapeable.FC<TopicTabsLayoutProps> = (props) => {
  const { className, children, entity, activeView, setActiveView } = props;

  const { color, connectedPages = [], events = [], committeeMembers = [],  citations = [], feedEntries = [], trend } = entity;

  const resources = sortBy([...citations, ...feedEntries], 'date');

  const filteredConnectedPages = filterEntitiesWithLinkedSite(connectedPages);

  const allconnections = compact([...filteredConnectedPages, trend, ...events]);
  
  const currentCommitteeMembers = useCurrentEditionMembers(committeeMembers, entity);

  const hasContributors = !!currentCommitteeMembers.length;
  const hasConnections = !!allconnections.length;
  const hasResources = !!resources.length;

  const tabs: ContentTabSpec<TopicView>[] = compact([
    {
      id: 'radar-ai',
      icon: <AiUpperCaseIconGlyph />
    },
    {
      id: 'overview',
      label: 'Overview',
    },
    hasConnections &&
    {
      id: 'connections',
      label: 'Connections',
      count: allconnections.length,
    },
    hasResources &&
    {
      id: 'resources',
      label: 'Resources',
      count: resources.length,
    },
    hasContributors &&
    {
      id: 'contributors',
      label: 'Committee',
      count: currentCommitteeMembers.length,
    }
  ]);

  const modal = useModal();
    
  const handleChatClick = () => {
    modal?.show(<AiChatInterfaceModal />, { color: '#000000', title: 'RadarAI', opacity: 0.5 });
  };

  const handleTabClick = (tabId: TopicView) => {
    if (tabId === 'radar-ai') {
      handleChatClick();
    } else {
      setActiveView(tabId);
    }
  };
  
  return (
    <My.Tabs onTabClick={handleTabClick} activeTab={activeView} items={tabs} colors={{ border: color?.value, hover: { text: color?.value } }} />
  )
};

TopicTabsLayout.defaultProps = TopicTabsLayoutDefaultProps;
TopicTabsLayout.cls = cls;